import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment from 'moment';

@Component({
    selector: 'app-journal-report',
    templateUrl: './journal-report.component.html',
    styleUrls: ['./journal-report.component.css']
})
export class JournalReportComponent implements OnInit {

    constructor(private accService: AccountingService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }



    PaymentModel = {
        CreditAccID: 0,
        DebitAccID: 0,
        Amount: 0,
        Narration: '',
        ChequeDate: '',
        ChequeNo: '',
    };


    PrintJournal() {
        this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate != '' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
        this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate!='' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
      

        var url = "journalreportprint?PrintType=JournalReport&FromDate=" + this.PaymentModelSearch.FromDate + "&ToDate=" + this.PaymentModelSearch.ToDate;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
    };
    onSelectCashSearch($item) {
        this.PaymentModelSearch.AccID = $item.ItemId;
    }
    SearchBankAccName = '';
    ClearSearch() {
        this.PaymentModelSearch.AccID = 0;
        this.PaymentModelSearch.FromDate = '';
        this.PaymentModelSearch.ToDate = '';
        this.SearchBankAccName = '';
    };
    PaymentModelSearch = {
        AccID: 0,
        FromDate: '',
        ToDate: ''
    };

    JournalList: any;
    loadingSearch = false;
    GetJournalReport() {

        this.loadingSearch = true;
        this.spinnerService.show();
        this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate != '' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
        this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate!='' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
        this.accService.GetJournalReport(JSON.stringify(this.PaymentModelSearch)).subscribe((response) => {
            this.JournalList = response.JournalList;
            this.spinnerService.hide();
            setTimeout(() => {

                this.loadingSearch = false;
                this.globalHelper.CheckActionStatus(response);
            }, 10);
        });
    };


    ngOnInit() {

        setTimeout(() => {

            this.PaymentModelSearch.FromDate = moment(this.globalHelper.GetLoginToken().SessionStartDate).format("DD-MMM-YYYY");

            this.PaymentModelSearch.ToDate = moment(this.globalHelper.GetLoginToken().SessionEndDate).format("DD-MMM-YYYY");

        }, 200);
    }

}
